var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:( _obj = {}, _obj['has-badge'] = !!_vm.badge, _obj ),attrs:{"variant":"primary","data-badge":_vm.badge}},[_vm._v(_vm._s(_vm.name))])
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }